<template>
  <v-btn small rounded color="teal" dark to="/simular-plano-saude" :disabled="meuPlano.solicitoualteracao" v-if="podeAlterarIncluir"
    ><v-icon size="17" color="white" class="mr-2">mdi-pencil</v-icon> Trocar
    plano</v-btn
  >
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: mapState("planoSaude", ["meuPlano","podeAlterarIncluir"]),
};
</script>

<style>
</style>